<template>
  <div class="GraphContainer">
    <div>
      <DxPieChart
        id="pie"
        :data-source="GraphCounts"
        type="doughnut"
        palette="Soft Pastel"
        :diameter=".9"
        :size="{height:180, width:180}"
        :customizePoint="CustomPie"
        center-template="centerTemplate"
      >
        <template #centerTemplate>
          <svg>
            <text :style="{ fill:&quot;#494949&quot;}" text-anchor="middle" x="100" y="120">
              <tspan
                :style="{ fontWeight: 600 }"
                x="100"
                dy="20px"
              >{{ chartCenterText }}</tspan>
            </text>
          </svg>
        </template>
        <DxSeries argument-field="text" selectionMode="none" hoverMode="none">
          <DxLabel :visible="false" position="inside">
            <DxConnector :visible="false" />
          </DxLabel>
        </DxSeries>
        <DxExport :enabled="false" />
        <DxLegend :visible="false" />
         <DxTooltip  
          :enabled="true"
          color="transparent"
          contentTemplate="toolTipTemp"
          >
        </DxTooltip>
          <template #toolTipTemp="{ data }">
            <div><ChartTooltip :toolTipVal="getToolTipValue(data)"/></div>
          </template>
      </DxPieChart>
    </div>
  </div>
</template>

<script>
import ChartTooltip from "../../../views/home/ChartTooltip";

import DxPieChart, {
  DxLegend,
  DxSeries,
  DxTooltip,
  DxFormat,
  DxLabel,
  DxConnector,
  DxExport,
} from "devextreme-vue/pie-chart";
export default {
  name: "InstallationProgChart",
  components: {
    DxPieChart,
    DxLegend,
    DxSeries,
    DxTooltip,
    DxFormat,
    DxLabel,
    DxConnector,
    DxExport,
    ChartTooltip,
  },
  props: {
    installDetails: Array,
    chartCenterText: String
  },
  data() {
    return {
      user: this.$auth.user.UserDetails,
      chartData: []
    }
  },
  computed: {
    GraphCounts() {
      return this.installDetails;

    /*[
        { 
          text: "Assessing", 
          val: 5, 
          color: "#006ca5" 
        },
        {
          text: "Installing",
          val: 10,
          color: "#f2bb01",
        },
        {
          text: "Live",
          val: 15,
          color: "#8BC549",
        },
        {
          text: "Decommission",
          val: 20,
          color: "#9C8AA5",
        },
      ]; */
    },
  },
  mounted: function (){
   
  },
  methods: {
    CustomPie(info) {
      return { color: info.data.color };
    },
    getToolTipValue(data){
      return data.argumentText + ' ('+ data.valueText+')';
    }
  },
};
</script>

<style lang="scss" scoped>
.GraphContainer {
  text-align: center;
}
</style>